/**
 * Runnability KPI for the /workflows listing — Loop Runtime PRD §5.5.
 *
 * GET /api/workflows/runnability returns the four scalar fields the KPI strip
 * renders. `blocked_roles` is the deduplicated list of role slugs blocking
 * one or more loops; the count is `blocked_roles.length`. Both
 * route+block consume this contract.
 */

import { z } from "zod";
import type { Operation } from "../../types";

export interface LoopsRunnability {
  total: number;
  runnable: number;
  blocked: number;
  blocked_roles: string[];
}

const response = z.object({
  total: z.number().int().nonnegative(),
  runnable: z.number().int().nonnegative(),
  blocked: z.number().int().nonnegative(),
  blocked_roles: z.array(z.string()),
});

const getOp: Operation<void, void, void, LoopsRunnability> = {
  method: "GET",
  path: () => "/api/workflows/runnability",
  response,
};

export const loopsRunnability = {
  get: getOp,
};
